import dayjs from "dayjs";

import { FlightsSortOptions } from "@/features/flights/types/types";
import { CabinClass, SortOrder, TripType } from "@/types/enums";
import { type FlightsSortValue } from "@/types/types";

export const initialFlightsValues = {
  tripType: TripType.ONE_WAY,
  from: null,
  to: null,
  dates: {
    departure: dayjs().add(1, "day").startOf("day").toDate(),
    return: dayjs().add(1, "day").startOf("day").toDate(),
  },
  cabinClass: CabinClass.ECONOMY,
  adult: 1,
  child: 0,
  infantWithoutSeat: 0,
};

export const initialSortValue: FlightsSortValue = {
  field: FlightsSortOptions.PRICE,
  order: SortOrder.ASC,
};
